import { cn } from "@/lib/utils";
import React from "react";

interface StatusCardProps extends React.HTMLAttributes<HTMLDivElement> {
  customBg?: string;
  customBorder?: string;
}

export const StatusCard = ({
  customBg,
  customBorder,
  className,
  children,
  ...props
}: StatusCardProps) => {
  return (
    <div
      {...props}
      style={{
        backgroundColor: customBg ?? "",
        border: customBorder ? `0.5px solid ${customBorder}` : "",
      }}
      className={cn(
        "text-background max-w-52 rounded-md flex items-center justify-center py-2",
        className
      )}
    >
      {children}
    </div>
  );
};
